import {createSelector} from '@ngrx/store';
import {getLangState} from '../state/index';
import {LangState} from './reducer';

export const getCurrentLang = createSelector(getLangState, (state: LangState) => state.lang);

